import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as fromInternationalData from '../reducers/international-data.reducer'

export const getInternationalDataState = createSelector(
  createFeatureSelector(fromInternationalData.internationalDataFeatureKey),
  (state) => state,
)

export const getInternationalDataEntities = createSelector(getInternationalDataState, fromInternationalData.getEntities)

export const getInternationalDataList = createSelector(getInternationalDataState, fromInternationalData.getList)

export const getInternationalDataLoading = createSelector(getInternationalDataState, fromInternationalData.getLoading)

export const getInternationalDataLoaded = createSelector(getInternationalDataState, fromInternationalData.getLoaded)
